import { render, staticRenderFns } from "./electAi.vue?vue&type=template&id=6d04c326"
import script from "./electAi.vue?vue&type=script&lang=js"
export * from "./electAi.vue?vue&type=script&lang=js"
import style0 from "./electAi.vue?vue&type=style&index=0&id=6d04c326&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports